import React from 'react'
import { FormGroup } from 'react-bootstrap'
import i18next from 'i18next'
import classnames from 'classnames'

import LanguageSelectorFormControl from './LanguageSelectorFormControl'

import listingStyles from './styles/listing.scss'
import Wopi360TargetListTableRow from './Wopi360TargetListTableRow'

export default class Wopi360TargetListTable extends React.Component {
  handleLanguageChange = e => {
    this.props.onChangeLanguage(e.target.value)
  }

  render() {
    const {
      targets,
      deletedTargets,
      latestClosedWopi360TargetUuid,
      hasLanguageSelector,
      onDeleteRow,
      deleteText,
      hideUnits,
      language
    } = this.props

    return (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th style={{ width: 140 }}>{i18next.t('target_person_and_role')}</th>
              <th>{hideUnits ? i18next.t('organisation') : i18next.t('organisation_and_units')}</th>
              <th>{i18next.t('questionnaire_opened')}</th>
              <th>{i18next.t('questionnaire_closed')}</th>
              <th>{i18next.t('test_state')}</th>
              <th>{i18next.t('number_of_recipients_responded')}</th>
              <th>
                {hasLanguageSelector && (
                  <FormGroup
                    bsSize="sm"
                    className={classnames('form-inline', listingStyles.profileExtrasForm)}
                  >
                    <LanguageSelectorFormControl
                      onChange={this.handleLanguageChange}
                      defaultValue={language}
                      showOnlyAdminLanguages={false}
                      shouldTranslateLanguages={true}
                      withoutFormGroup
                    />
                  </FormGroup>
                )}
              </th>
              <th />
            </tr>
          </thead>

          <tbody>
            {targets.map(target => (
              <Wopi360TargetListTableRow
                key={target.uuid}
                target={target}
                language={language}
                isDeleted={deletedTargets.contains(target.uuid)}
                isClosed={latestClosedWopi360TargetUuid === target.uuid}
                onDelete={onDeleteRow}
                deleteText={deleteText}
                hideUnits={hideUnits}
              />
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetListTable.js